import { Pipe, PipeTransform } from '@angular/core';
import { catchError, isObservable, map, Observable, of, startWith } from 'rxjs';
import { LivErrorResponse } from 'src/app/core/models/liv-response-protocol.model';

type ValueProps<Value> = {
  data: Value;
  type: 'idle' | 'start' | 'end';
};

type ValueResponse<T> =
  | Observable<
      | {
          loading: boolean;
        }
      | {
          loading: boolean;
          value: T;
        }
      | {
          loading: boolean;
          error: LivErrorResponse;
        }
    >
  | T;

@Pipe({
    name: 'withLoading',
    standalone: false
})
export class WithLoadingPipe implements PipeTransform {
  transform<Value extends ValueProps<Value>>(
    value: Value
  ): ValueResponse<Value> {
    return isObservable(value)
      ? value.pipe(
          map((value: Value) => ({
            loading: value.type === 'start',
            value: value.data
          })),
          startWith({ loading: true }),
          catchError(({ error }: LivErrorResponse) =>
            of({ loading: false, error })
          )
        )
      : value.data;
  }
}
